import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function LocalHeroIcon(props: Props) {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
            <path d="M12.9814 5.9254L12 2L11.0187 5.9254C10.3917 8.4334 8.4334 10.3917 5.9254 11.0186L2 12L5.9254 12.9813C8.4334 13.6083 10.3917 15.5666 11.0186 18.0746L12 22L12.9813 18.0746C13.6083 15.5666 15.5666 13.6083 18.0746 12.9814L22 12L18.0746 11.0187C15.5666 10.3917 13.6083 8.4334 12.9814 5.9254Z" />
        </svg>
    );
}
